/*! Product page sticky add-to-cart bar — always visible */
import { formatMoney } from "utils";

class ProductStickyAtc extends HTMLElement {
  #btnObserver;
  #stagedObserver;

  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.productSingle = document.querySelector("product-single");
    this.mainAddBtn = this.productSingle?.querySelector(".js-product-add");
    this.mainStagedAction = this.mainAddBtn?.querySelector("staged-action");
    this.priceEl = this.querySelector(".product-sticky-atc__price");
    this.imageEl = this.querySelector(".product-sticky-atc__image");
    this.btn = this.querySelector(".product-sticky-atc__btn");
    this.stickyStagedAction = this.btn?.querySelector("staged-action");

    this.classList.add("is-visible");
    document.documentElement.classList.add("has-product-sticky-atc");

    if (!this.mainAddBtn || !this.btn) return;

    this.btn.addEventListener("click", () => {
      if (this.mainAddBtn.disabled) return;
      this.mainAddBtn.click();
    });

    this.#btnObserver = new MutationObserver(() => this.#syncButtonState());
    this.#btnObserver.observe(this.mainAddBtn, {
      attributes: true,
      attributeFilter: ["disabled"],
      subtree: true,
    });

    if (this.mainStagedAction && this.stickyStagedAction) {
      this.#stagedObserver = new MutationObserver(() => this.#syncStagedActionState());
      this.#stagedObserver.observe(this.mainStagedAction, {
        attributes: true,
        attributeFilter: ["class"],
      });
      this.#syncStagedActionState();
    }

    this.productSingle
      ?.querySelectorAll("variant-selects, variant-radios, variant-swatches, variant-mixed-inputs")
      .forEach((selector) => {
        selector.addEventListener("on:variant:change", (event) => {
          this.#updateVariant(event.detail?.variant);
        });
      });

    this.#syncButtonState();
    this.#syncPriceFromDom();
  }

  disconnectedCallback() {
    this.#btnObserver?.disconnect();
    this.#stagedObserver?.disconnect();
    document.documentElement.classList.remove("has-product-sticky-atc");
  }

  #syncStagedActionState() {
    if (!this.mainStagedAction || !this.stickyStagedAction) return;
    this.stickyStagedAction.classList.toggle("is-doing", this.mainStagedAction.classList.contains("is-doing"));
    this.stickyStagedAction.classList.toggle("is-done", this.mainStagedAction.classList.contains("is-done"));
  }

  #syncButtonState() {
    if (!this.mainAddBtn || !this.btn) return;
    this.btn.disabled = this.mainAddBtn.disabled;
    const mainLabel = this.mainAddBtn.querySelector("staged-action-text");
    const stickyLabel = this.btn.querySelector("staged-action-text");
    if (mainLabel?.textContent?.trim() && stickyLabel) {
      stickyLabel.textContent = mainLabel.textContent.trim();
    }
  }

  #syncPriceFromDom() {
    if (!this.priceEl || !this.sectionId) return;
    const priceContainer = document.getElementById(`price-${this.sectionId}`);
    const money = priceContainer?.querySelector(".price__number .money, .money");
    if (money?.textContent?.trim()) {
      this.priceEl.textContent = money.textContent.trim();
    }
  }

  #updateVariant(variant) {
    if (!variant) return;

    if (this.priceEl && window.theme?.money_product_price_format) {
      this.priceEl.textContent = formatMoney(variant.price, window.theme.money_product_price_format);
    } else {
      this.#syncPriceFromDom();
    }

    if (this.imageEl && variant.featured_media?.preview_image?.src) {
      const src = variant.featured_media.preview_image.src;
      this.imageEl.src = src.includes("?") ? `${src}&width=120` : `${src}?width=120`;
    }

    this.#syncButtonState();
  }
}

customElements.define("product-sticky-atc", ProductStickyAtc);
